/* 1) Ofertas de varias unidades: el cliente elige la variante (talla, color...) de cada unidad,
      en burbujas, con las unidades una al lado de otra ("Producto 1" | "Producto 2").
   2) Añadir al carrito a prueba de fallos: si la petición falla, se envía el formulario normal
      (lleva al carrito), así nunca se queda sin añadir. */
(function () {
  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };

  function variants() {
    var n = qs('[data-product-variants]');
    if (!n) return [];
    try { return JSON.parse(n.textContent || '[]'); } catch (_) { return []; }
  }
  function currentVariantId() {
    var sel = qs('[data-variant-select]');
    var hid = qs('[data-variant-id]');
    return String((sel && sel.value) || (hid && hid.value) || '');
  }
  function css() {
    if (document.getElementById('dv-uv-css')) return;
    var s = document.createElement('style');
    s.id = 'dv-uv-css';
    s.textContent =
      '.dv-uv{display:grid;grid-template-columns:repeat(var(--uv-cols,2),minmax(0,1fr));gap:8px;margin:-2px 0 9px}' +
      '.dv-uv__unit{border:1px solid color-mix(in srgb,var(--accent,#3e694d) 35%,#fff);border-radius:12px;padding:7px 8px 8px;background:#fff;min-width:0}' +
      '.dv-uv__label{display:block;font-size:12px;font-weight:800;margin:0 0 5px;text-align:center}' +
      '.dv-uv__pills{display:flex;gap:5px;justify-content:center;flex-wrap:wrap}' +
      '.dv-uv__pill{min-width:34px;height:30px;padding:0 9px;border-radius:999px;border:2px solid #d6dce1;background:#fff;font:inherit;font-size:13px;font-weight:700;color:#20251f;cursor:pointer;line-height:1}' +
      '.dv-uv__pill.is-color{width:28px;min-width:28px;height:28px;padding:0;border:2px solid #fff;box-shadow:0 0 0 1px rgba(0,0,0,.18)}' +
      '.dv-uv__pill.is-active{border-color:var(--accent,#3e694d);background:color-mix(in srgb,var(--accent,#3e694d) 12%,#fff)}' +
      '.dv-uv__pill.is-color.is-active{box-shadow:0 0 0 2px var(--accent,#3e694d)}' +
      '.dv-uv__pill[disabled]{opacity:.35;cursor:not-allowed}' +
      '.drevia-variant-picker.dv-uv-hidden{display:none!important}' +
      '.dv-atc-msg{display:block;margin-top:8px;font-size:12px;color:#a8420f}';
    document.head.appendChild(s);
  }
  function selectedOffer() { return qs('.drevia-offer.is-selected'); }
  function isUnitOffer(o) {
    if (!o) return false;
    return !!window.dvUnitVariants && Number(o.dataset.quantity || 1) > 1 && !o.dataset.swapVariantId && variants().length > 1;
  }
  function shortName(v) { return String(v.title || '').split(' / ')[0]; }

  function render() {
    var offer = selectedOffer();
    var box = qs('.dv-uv');
    var on = isUnitOffer(offer);
    qsa('.drevia-variant-picker').forEach(function (p) { p.classList.toggle('dv-uv-hidden', on); });
    if (!on) { if (box) box.remove(); return; }
    var qty = Math.max(1, Number(offer.dataset.quantity || 1));
    if (box && box.dataset.for === offer.id + ':' + qty && box.previousElementSibling === offer) return;
    if (box) box.remove();
    css();
    var vs = variants();
    var cur = currentVariantId();
    if (!vs.some(function (v) { return String(v.id) === cur && v.available; })) {
      var first = vs.filter(function (v) { return v.available; })[0];
      cur = first ? String(first.id) : cur;
    }
    box = document.createElement('div');
    box.className = 'dv-uv';
    box.dataset.for = offer.id + ':' + qty;
    box.style.setProperty('--uv-cols', Math.min(qty, 3));
    for (var i = 1; i <= qty; i++) {
      var unit = document.createElement('div');
      unit.className = 'dv-uv__unit';
      unit.dataset.value = cur;
      var lab = document.createElement('span');
      lab.className = 'dv-uv__label';
      lab.textContent = 'Producto ' + i;
      var pills = document.createElement('div');
      pills.className = 'dv-uv__pills';
      vs.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        var name = shortName(v);
        var c = window.dvColorFor ? window.dvColorFor(name) : null;
        b.className = 'dv-uv__pill' + (c ? ' is-color' : '') + (String(v.id) === cur ? ' is-active' : '');
        b.dataset.value = v.id;
        b.title = name;
        b.setAttribute('aria-label', 'Producto ' + i + ': ' + name);
        if (c) b.style.background = c; else b.textContent = name;
        if (!v.available) b.disabled = true;
        pills.appendChild(b);
      });
      unit.appendChild(lab);
      unit.appendChild(pills);
      box.appendChild(unit);
    }
    offer.insertAdjacentElement('afterend', box);
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest && e.target.closest('.dv-uv__pill');
    if (pill) {
      e.preventDefault();
      var unit = pill.closest('.dv-uv__unit');
      unit.dataset.value = pill.dataset.value;
      qsa('.dv-uv__pill', unit).forEach(function (b) { b.classList.toggle('is-active', b === pill); });
      return;
    }
    if (e.target.closest && e.target.closest('[data-offer]')) setTimeout(render, 0);
  });

  function openCart() {
    var t = document.createElement('span');
    t.setAttribute('data-cart-open', '');
    t.style.display = 'none';
    document.body.appendChild(t);
    t.click();
    setTimeout(function () { t.remove(); }, 0);
  }
  function msg(form, text) {
    var m = qs('.dv-atc-msg', form);
    if (!m) { m = document.createElement('small'); m.className = 'dv-atc-msg'; var b = qs('[data-add-button]', form); (b || form).insertAdjacentElement('afterend', m); }
    m.textContent = text || '';
  }
  // Ofertas con extras (pack de otro producto, regalo, código o complementos marcados): las sigue gestionando el tema
  function themeHandles(offer) {
    if (offer && (offer.dataset.swapVariantId || offer.dataset.giftVariantId || offer.dataset.discountCode)) return true;
    return qsa('.drevia-upsell__input:checked').length > 0;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-product-form]');
    if (!form) return;
    var offer = selectedOffer();
    var items;
    if (isUnitOffer(offer)) {
      var counts = {};
      qsa('.dv-uv__unit').forEach(function (u) { counts[u.dataset.value] = (counts[u.dataset.value] || 0) + 1; });
      items = Object.keys(counts).filter(Boolean).map(function (id) { return { id: Number(id), quantity: counts[id] }; });
    } else {
      if (themeHandles(offer)) return;
      var id = Number(currentVariantId());
      var qInput = qs('[data-main-quantity]', form);
      var qty = offer ? Math.max(1, Number(offer.dataset.quantity || 1)) : Math.max(1, Number((qInput && qInput.value) || 1));
      items = id ? [{ id: id, quantity: qty }] : [];
    }
    if (!items.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    msg(form, '');
    var btn = qs('[data-add-button]', form);
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    function done() { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } }
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || 'No se pudo añadir');
      });
    }).then(function () {
      done();
      openCart();
    }).catch(function (err) {
      done();
      msg(form, (err && err.message) || 'No se pudo añadir. Probamos de otra forma…');
      // Plan B: envío normal del formulario (lleva al carrito con el producto)
      var hid = qs('[data-variant-id]', form);
      if (hid) hid.value = items[0].id;
      var q = qs('input[name="quantity"]', form);
      if (q) q.value = items[0].quantity;
      HTMLFormElement.prototype.submit.call(form);
    });
  }, true);

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-variant-select]')) {
      var v = e.target.value;
      qsa('.dv-uv__unit').forEach(function (u) {
        u.dataset.value = v;
        qsa('.dv-uv__pill', u).forEach(function (b) { b.classList.toggle('is-active', b.dataset.value === v); });
      });
    }
  });
  function init() {
    qsa('[data-offer]').forEach(function (o, i) { if (!o.id) o.id = 'dv-offer-' + (i + 1); });
    render();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  ['shopify:section:load', 'shopify:block:select'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(init, 60); }); });
})();
